import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormattedMessage } from 'react-intl';
import { ADGMTextField } from 'aurora-components';
import messages from 'aurora-translations';
import { Grid, Hidden } from '@material-ui/core';
import styles from './styles';

function ContactFields(props) {
  const { classes, modalConfig, formState, handleStateChange } = props;

  const userData = modalConfig?.data;
  return (
    <div className={classes.inputGridContainer2}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ADGMTextField
            name='name'
            type='text'
            label={<FormattedMessage {...messages.Name_English_bracket} />}
            required
            // onChange={handleStateChange}
            value={userData?.nameEn}
            disabled
          />
        </Grid>
        <Hidden smDown>
          <Grid item xs={12} md={6}>
            <ADGMTextField
              name='name'
              type='text'
              label={<FormattedMessage {...messages.Name_Arabic_bracket} />}
              required
              value={userData?.nameAr}
              disabled
            />
          </Grid>
        </Hidden>
        <Grid item md={6} xs={12}>
          <ADGMTextField
            name='mobile'
            type='text'
            label={<FormattedMessage {...messages.Phone_Number} />}
            required
            onChange={handleStateChange}
            value={formState?.mobile}
            // disabled
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <ADGMTextField
            name='email'
            type='text'
            label={<FormattedMessage {...messages.email_id} />}
            required
            onChange={handleStateChange}
            value={formState?.email || ''}
            // disabled
          />
        </Grid>
      </Grid>
    </div>
  );
}

ContactFields.propTypes = {
  classes: PropTypes.object.isRequired,
  formState: PropTypes.object.isRequired,
  modalConfig: PropTypes.object.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  handleSelect: PropTypes.func,
};

ContactFields.defaultProps = {
  handleSelect: null,
};

export default withStyles(styles)(ContactFields);
